module.exports = __webpack_public_path__ + "static/media/tourism-boards-10.19e3066a.jpg";